import React from 'react';
import './SubHeader.css';

const SubHeader = ({ text }) => {
    return (
        <div dangerouslySetInnerHTML={{__html: text.replace(/&nbsp;/g, ' ')}} className={'SubHeader'}></div>
    );
};

export default SubHeader;
